import {ref} from 'vue'

const intercept = ref(false)
const interceptMessage = ref('Leave site? Changes that you made may not be saved.')

export default () => {

    function enableIntercept() {
        intercept.value = true
    }
  
    function disableIntercept() {
        intercept.value = false
    }

    function setInterceptMessage(message) {
        interceptMessage.value = message
    }

    function resetInterceptMessage() {
        interceptMessage.value = 'Leave site? Changes that you made may not be saved.'
    }

    return {intercept, interceptMessage, enableIntercept, disableIntercept, setInterceptMessage, resetInterceptMessage}
}